import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ArrowLeftRight, CheckCircle2, Loader2, RefreshCw, Unlink } from "lucide-react";
import { finApi, apiErr } from "../api";
import { useFin, Card } from "../FinanceApp";
import { Button } from "../../components/ui/button";
import { SyncLog, askFromDate } from "../../components/FinLinkPanel";

// Finance side: WorkZone (HR) link status, back-fill and sync log
export const WorkzoneLinkCard = () => {
  const { can } = useFin();
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => finApi.workzoneLink().then(setD).catch(() => setD(null));
  useEffect(() => { load(); }, []);
  if (!d) return null;
  const backfill = async () => {
    const fd = askFromDate();
    if (fd === null) return;
    setBusy(true);
    try { const r = await finApi.workzoneBackfill(fd); toast.success(r.added ? `تم إرسال ${r.added} فاتورة إلى إيرادات WorkZone` : "كل الفواتير موجودة مسبقاً"); load(); }
    catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };
  return (
    <Card className="space-y-3 p-5 lg:col-span-2" data-testid="fin-workzone-link">
      <div className="flex flex-wrap items-center gap-2">
        <ArrowLeftRight className="h-5 w-5 text-teal-600" /><span className="text-sm font-bold text-slate-800">الربط مع نظام WorkZone</span>
        {d.linked ? <span className="inline-flex items-center gap-1 rounded-full bg-emerald-100 px-2.5 py-0.5 text-xs font-bold text-emerald-800" data-testid="fin-workzone-linked"><CheckCircle2 className="h-3.5 w-3.5" /> مربوط مع {d.org_name}</span>
          : <span className="inline-flex items-center gap-1 rounded-full bg-amber-100 px-2.5 py-0.5 text-xs font-bold text-amber-800" data-testid="fin-workzone-unlinked"><Unlink className="h-3.5 w-3.5" /> غير مربوط</span>}
        <span className="flex-1" />
        {d.linked && can("opening.manage") && <Button size="sm" variant="outline" disabled={busy} onClick={backfill} className="gap-1.5" data-testid="fin-workzone-backfill">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />} إرسال الفواتير السابقة للإيرادات</Button>}
      </div>
      {d.linked ? <SyncLog log={d.log} /> : <p className="text-xs text-slate-500">يتم الربط تلقائياً عندما يكون بريدك هنا هو نفس بريد مدير الشركة في WorkZone، أو من WorkZone عبر زر «غير مربوط» بجانب «WorkZone المحاسبي».</p>}
    </Card>
  );
};
